import script from "./AddUserToGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserToGroupModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserToGroupModal.vue?vue&type=style&index=0&id=5c6d2b1e&lang=scss&scoped=true"
import "./AddUserToGroupModal.vue?vue&type=style&index=1&id=5c6d2b1e&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c6d2b1e"]])

export default __exports__